import { render, staticRenderFns } from "./ProfessionSetting.vue?vue&type=template&id=74b5a0a4"
import script from "./ProfessionSetting.vue?vue&type=script&lang=js"
export * from "./ProfessionSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports